import React from 'react';
import { Link } from 'react-router';
import BackButton from "../../common/elements/BackButton";
import Anchor from "../../dashboardNew/objects/Anchor";

const networkIdRedirection = (location, router) => {
    if (
        location &&
        location.pathname &&
        (
            location.pathname.includes('/NED') ||
            location.pathname.includes('/TCH') ||
            location.pathname.includes('/FDN') ||
            location.pathname.includes('/WD') ||
            location.pathname.includes('/ID')
        )
    ) {
        const redirectURL = location.pathname
            .replace("/NED", "")
            .replace("/TCH", "")
            .replace("/FDN", "")
            .replace("/WD", "")
            .replace("/ID", "");
        router.push(redirectURL)
    }
}

export const NotFound = (props) => {

    const { location, router } = props;
    const isUS = localStorage.getItem( 'site_of_origin' ).toLowerCase() !== 'us';
    networkIdRedirection(location, router);
    
    return (
        <article className="notfound container-fluid">
            <div className="h-100 row">
                <div className="h-100 col-12">
                    <div className="notfound__content-background">
                        <div className="content-main">
                            <div className="content-main__title text-center">
                                <h1 className="h1 title">The page you're looking for cannot be found.</h1>
                                <h3 className="h3 subtitle">We are very sorry for the inconvenience.</h3>
                                <div className="hidden-sm hidden-md hidden-lg">
                                    <BackButton />
                                </div>
                            </div>
                            <div className="content-main__content content">
                                <div className="content__logo hidden-sm hidden-md hidden-lg">
                                    <img className="logo" src="/images/error-pages/icon-404.svg" alt="404 page" />
                                </div>
                                <div className="content__links--01">
                                    <p className="p-tag">Perhaps you were looking for one of the following sections:</p>
                                    <ul>
                                        <li><Anchor path={'/'}>Home</Anchor></li>
                                        <li><Anchor path={'/blog'}>Blog</Anchor></li>
                                        <li><Anchor path={'/forums'}>Forums</Anchor></li>
                                        <li><Anchor path={'/my-jobs'}>My jobs</Anchor></li>
                                        <li><Anchor path={'/writing-services'}>Writing services</Anchor></li>
                                        <li><Anchor path={'/ask-an-expert'}>Ask an expert</Anchor></li>
                                    </ul>
                                </div>
                                <div className="content__links--02 content">
                                    <div className="content__logo hidden-xs">
                                        <img className="logo" src="/images/error-pages/icon-404.svg" alt="404 page" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </article>
    );
}



// WEBPACK FOOTER //
// src/client/components/site/pages/NotFound.js